<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="12"
                md="6"
                xl="4"
              >
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search by description or tag"
                  single-line
                  hide-details
                />
              </v-col>
              <v-col
                cols="12"
                md="3"
                offset-md="3"
                xl="2"
                offset-xl="6"
              >
                <setup-job-descriptions-dialog-create 
                  class="mx-1" 
                  @created="loadData"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :loading="loading"
            :headers="headers"
            :items="jobDescriptions"
            :search="search"
            :custom-filter="filter"
            hide-default-header
          >
            <template v-slot:item.value="{ item }">
              <div class="py-2">
                <p>{{ item.value }}</p>
                <div>
                  <v-chip 
                    v-for="tag in item.tags" 
                    :key="tag.id"
                    color="primary"
                    class="ma-1"
                    label
                    outlined
                    small
                  >
                    {{ tag.name }}
                  </v-chip>
                </div>
              </div>
            </template>
            <template v-slot:item.skill="{ item }">          
              <v-container>                    
                <v-row>
                  <v-col>
                    <setup-job-descriptions-skills-chip 
                      v-for="skill in item.skills" 
                      :key="skill.id"
                      :job-description-id="item.id"
                      :skill="skill"
                      @deleted="loadData"
                    />   
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-slot:item.action="{ item }">
              <v-card-actions>
                <setup-job-descriptions-skills-dialog-create 
                  :job-description-id="item.id"
                  @added="loadData"
                />
                <setup-job-descriptions-dialog-edit 
                  :job-description="item"
                  @updated="loadData"
                />
                <span class="mx-1" />
                <setup-job-descriptions-dialog-delete 
                  :job-description="item"
                  @deleted="loadData"
                />
              </v-card-actions>
            </template>       
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupJobDescriptionsDialogCreate: () => import('@/components/setup/job-descriptions/DialogCreate'),
      SetupJobDescriptionsSkillsChip: () => import('@/components/setup/job-descriptions/skills/Chip'),
      SetupJobDescriptionsSkillsDialogCreate: () => import('@/components/setup/job-descriptions/skills/DialogCreate'),
      SetupJobDescriptionsDialogEdit: () => import('@/components/setup/job-descriptions/DialogEdit'),
      SetupJobDescriptionsDialogDelete: () => import('@/components/setup/job-descriptions/DialogDelete'),
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          {
            text: 'Description',
            align: 'left',
            sortable: false,
            value: 'value',
          },
          {
            text: 'Skills',
            align: 'left',
            sortable: false,
            filterable: false,
            value: 'skill',
          },
          {
            text: 'Actions',
            sortable: false,
            filterable: false,
            value: 'action',
          },
        ],
        jobDescriptions: [],
      }
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.jobDescriptions().list(['tags', 'skills'])
          .then(response => {
            this.jobDescriptions = response.data

            this.loading = false
          })
      },
      filter (value, search, item) {
        const upperCaseSearch = search.toUpperCase()

        return value != null &&
          search != null &&
          typeof value === 'string' &&
          (value.toString().toUpperCase().indexOf(upperCaseSearch) !== -1 ||
            item.tags.find(tag => tag.name.toUpperCase().indexOf(upperCaseSearch) > -1) !== undefined)
      },
    },
  }
</script>
